import AboutUsComponent from "../../components/AboutUs/AboutUsComponent";
import Clients from "../../components/Clients/Clients";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/Hero Section/HeroSection";
import Navbar from "../../components/Navbar/Navbar";
import Testimonial from "../../components/Testimonials/Testimonial";
import WhyNobel from "../../components/WhyNobelAI/WhyNobel";
import SolutionsSection from "../../components/Solutions/SolutionsSection";

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection variant={2} />

      <AboutUsComponent />
      <WhyNobel variant="full" />
      <SolutionsSection />
      <Testimonial />
      <Clients />
      <Footer />
    </div>
  );
};

export default LandingPage;
